import africanCountries from "./data/africanCountries.json";
import africanCultures from "./data/africanCultures.json";

export const AFRICAN_COUNTRIES = Object.values(africanCountries).map(
  (country) => country.name,
);
export const AFRICAN_CULTURES = africanCultures.map((row) => row.culture);

export const CULTURES_AND_COUNTRIES = [
  ...AFRICAN_COUNTRIES,
  ...AFRICAN_CULTURES,
] as const;

// MoMA data contains such for a lot of countries, so we need to filter upon local indexing
export const MOMA_FILTER_KEYWORDS = [
  "Africa",
  "Nigeria",
  "Igbo",
  ...CULTURES_AND_COUNTRIES,
];

export const USE_EMBEDDING_SEARCH = typeof process !== "undefined" && process.env !== undefined && process.env.USE_EMBEDDING_SEARCH === "true";
